import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { Component, OnInit, DoCheck, Output } from "@angular/core";
import {
  ConnectionStatus,
  ConnectionStatusPromiseService,
  ConnectionStatusState,
} from "shared/broker-client-services";
import { BfxBlotterOrdersService } from "app/bfx-blotter-orders/bfx-blotter-orders.service";
import { BfxAppStatusService } from "app/bfx-common/services/bfx-app-status.service";
import { Subscription } from "rxjs";
import { SystemControlImpl, SystemControlStatus } from "shared/cubiq-model-multi-asset";
import { BehaviorSubject } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

const DEFAULT_BODY_CLASS = " bfx-app-alert-container";
const DEFAULT_TITLE_CLASS = " bfx-app-alert-header-text";

@Component({
  selector: "bfx-app-alert-container",
  templateUrl: "./bfx-app-alert-container.html",
  standalone: false,
})
export class BfxAppAlertContainerComponent implements OnInit, DoCheck {
  /** When true, header is visible */
  public hasAlert: boolean = false;
  /** Icon displayed in the header */
  public alertIconClass: string;

  /** Text displayed in the header */
  public alertText: string;

  public bodyClasses = DEFAULT_BODY_CLASS;
  public titleClasses = DEFAULT_TITLE_CLASS;

  private connectionStatus: any = ConnectionStatusState.NONE;
  private inPanicMode: boolean = false;

  @Output()
  public onChange: BehaviorSubject<any> = new BehaviorSubject(null);

  private subscriptions: Subscription[] = [];

  private changePending: boolean = true;
  ratesPaused: boolean;

  constructor(
    private _connectionStatusService: ConnectionStatusPromiseService,
    private _blotterOrdersService: BfxBlotterOrdersService,
    private _appStatusService: BfxAppStatusService,
    private translationService: TranslateService,
  ) {}

  ngOnInit() {
    let subscription: Subscription;
    subscription = this._connectionStatusService
      .getConnectionEvents()
      .subscribe((event: ConnectionStatus) => {
        this.processStatusEvent(event);
      });
    this.subscriptions.push(subscription);

    subscription = this._appStatusService.castChange.subscribe(
      (panicEvents: SystemControlImpl[]) => {
        this.processPanicStatusEvents(panicEvents);
      },
    );
    this.subscriptions.push(subscription);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  ngDoCheck(): void {
    const ratesPaused = this._blotterOrdersService.areRatesPaused();

    if (this.changePending || ratesPaused != this.ratesPaused) {
      if (
        this.connectionStatus === ConnectionStatusState.CONNECTED ||
        this.connectionStatus === ConnectionStatusState.NONE
      ) {
        if (ratesPaused || this.inPanicMode) {
          const msgs: string[] = [];
          this.hasAlert = true;
          this.alertIconClass = "icon_ion_warning_filled";
          this.bodyClasses = `${DEFAULT_BODY_CLASS} bfx-alert-warn`;
          this.titleClasses = `${DEFAULT_TITLE_CLASS} bfx-alert-warn-title`;
          if (ratesPaused) {
            msgs.push(this.translationService.instant("app.alert.rates_paused"));
          }
          if (this.inPanicMode) {
            msgs.push(this.translationService.instant("app.alert.panic_enabled"));
          }
          this.alertText = msgs.join(" - ");
        } else {
          this.hasAlert = false;
          this.alertIconClass = null;
          this.bodyClasses = DEFAULT_BODY_CLASS;
          this.titleClasses = DEFAULT_TITLE_CLASS;
        }
      } else {
        this.hasAlert = true;
        this.alertIconClass = "icon_ion_error_filled";
        this.alertText = this.translationService.instant("app.alert.connection_lost");
        this.bodyClasses = `${DEFAULT_BODY_CLASS} bfx-alert-danger`;
        this.titleClasses = `${DEFAULT_TITLE_CLASS} bfx-alert-danger-title`;
      }
      this.changePending = false;
      this.ratesPaused = ratesPaused;
      this.onChange.next(this.alertIconClass);
    }
  }

  //  public get status(): string {
  //   let status;

  //   if (
  //     this.connectionStatus === ConnectionStatusState.CONNECTED ||
  //     this.connectionStatus === ConnectionStatusState.NONE
  //   ) {
  //     if (this._blotterOrdersService.areRatesPaused() || this.inPanicMode) {
  //       status = `warning`;
  //       this.alertText =
  //     }
  //     else{
  //       status = `normal`;
  //     }
  //   } else {
  //     status = `danger`;
  //   }

  //   return status;
  // }

  private processStatusEvent(event: any): void {
    this.connectionStatus = event.connectionStatus;
    this.changePending = true;
  }

  private processPanicStatusEvents(panicEvents: SystemControlImpl[]) {
    this.inPanicMode =
      Array.isArray(panicEvents) &&
      panicEvents.length !== 0 &&
      panicEvents.some((item) => item.systemControlStatus === SystemControlStatus.OFFLINE);
    this.changePending = true;
  }
}
